<template>
  <div class="popup-help popup-all">
    <div class="popup-container">
      <div class="popup-vue need-help">
          <img class="popup-close" src="/img/credit-landing-vue/popup-close.svg" alt="Close" @click="popupClose()">
          <div class="popup-title" v-if="contentLoaded" v-html="title"></div>
          <div class="popup-description content" v-if="contentLoaded" v-html="description"></div>
          <div v-else class="popup-spinner">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'popup-help',
        data() {
            return {
                visibility : false,
                title : '',
                description : '',
                contentLoaded: false
            }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            togglerPopup: function () {
                this.visibility =!this.visibility;
                this.scrollBottom();
            },
            popupShow: function () {
                this.$el.style.display = 'block';
                if (!this.contentLoaded) {
                  this.getContent();
                }
            },
            popupClose: function () {
                this.$el.style.display = 'none';
            },
            scrollBottom: function () {
                setTimeout(function () {
                    document.querySelector(".popup-help .need-help").scrollTo({
                        top: document.body.clientHeight,
                        behavior: "smooth"
                    });
                }, 300)

            },

          getContent: function () {
            const self = this;
            jQuery.ajax({
              headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
              },
              type: "GET",
              url: '/cash/cash-conditions',
              cache: false,
              dataType: "json",
              success: function (response) {
                self.title = response.title;
                self.description = response.description;
                self.contentLoaded = true;
              },
              error: function (error) {

              }
            });
          }
        }
    }

</script>
